import React, {Component} from 'react';
import Auth, {Permission} from '../../utils/auth';
import {Breadcrumb} from 'antd';
import {Query} from 'react-apollo';
import {adopt} from 'react-adopt';

import SelectRegion from './components/SelectRegion';
import SelectClub from './components/SelectClub';
import MembershipList from './components/MembershipList';
import MembershipDetail from './components/MembershipDetail';

import {GET_REGION, GET_CLUB, GET_MEMBERSHIPS} from './graphql';
import {Link, RouteComponentProps, withRouter} from 'react-router-dom';
import {Region, Club, ListMembership} from './interfaces';

interface BreadCrumbsQueriesData {
  region?: Region;
  club?: Club;
  membership?: ListMembership;
}

const BreadCrumbsQueries = adopt({
  region: ({render, regionId}) => {
    if (regionId) {
      return (
        <Query query={GET_REGION} variables={{regionId}}>
          {({loading, error, data}: any) => {
            if (loading || error) {
              return render(null);
            }
            const {region}: {region: Region} = data;
            return render(region);
          }}
        </Query>
      );
    }
    return render(null);
  },
  club: ({render, clubId}) => {
    if (clubId) {
      return (
        <Query query={GET_CLUB} variables={{clubId}}>
          {({loading, error, data}: any) => {
            if (loading || error) {
              return render(null);
            }
            const {club}: {club: Club} = data;
            return render(club);
          }}
        </Query>
      );
    }
    return render(null);
  },
  membership: ({render, clubId, membershipExternalId}) => {
    if (clubId && membershipExternalId) {
      return (
        <Query query={GET_MEMBERSHIPS} variables={{clubId}}>
          {({loading, error, data}: any) => {
            if (loading || error) {
              return render(null);
            }
            const {memberships}: {memberships: Array<ListMembership>} = data;
            return render(memberships.find(membership => membership.membershipExternalId === membershipExternalId));
          }}
        </Query>
      );
    }
    return render(null);
  }
});

class MembershipsPage extends Component<RouteComponentProps> {
  grantPermission(regionId: string, type: Permission): boolean {
    const roles: Array<string> = Auth.getRoles();
    const regionRoles = roles.filter(role => role.includes('regionRole'));
    const requiredRoles = regionRoles.filter(role => role.includes(type)).map(role => role.split(':')[1]);

    if (roles.some(role => role === 'admin')) {
      return true;
    }

    return requiredRoles.some(allowedRegion => allowedRegion === regionId);
  }

  createLink(url: string, name: string) {
    return <Link to={`/memberships/${url}`}>{name}</Link>;
  }

  getPath() {
    return window.location.pathname.substr(1).split('/');
  }

  getScene() {
    const path = this.getPath();

    if (path[1] && !this.grantPermission(path[1], Permission.Memberships)) {
      this.props.history.push('/error/authorization');
      return <div />;
    }

    if (path[3]) {
      return <MembershipDetail membershipExternalId={path[3]} clubId={path[2]} regionId={path[1]} />;
    } else if (path[2]) {
      return <MembershipList clubId={path[2]} regionId={path[1]} />;
    } else if (path[1]) {
      return <SelectClub regionId={path[1]} />;
    }

    return <SelectRegion />;
  }

  getBreadCrumbs() {
    const path = this.getPath();

    if (path[3]) {
      return (
        <BreadCrumbsQueries regionId={path[1]} clubId={path[2]} membershipExternalId={path[3]}>
          {({region, club, membership}: BreadCrumbsQueriesData) => {
            if (region && club && membership) {
              return (
                <Breadcrumb>
                  <Breadcrumb.Item>{this.createLink(region.id, region.name)}</Breadcrumb.Item>
                  <Breadcrumb.Item>{this.createLink(`${region.id}/${club.id}`, club.name)}</Breadcrumb.Item>
                  <Breadcrumb.Item>{membership.title}</Breadcrumb.Item>
                </Breadcrumb>
              );
            }
            return null;
          }}
        </BreadCrumbsQueries>
      );
    } else if (path[2]) {
      return (
        <BreadCrumbsQueries regionId={path[1]} clubId={path[2]}>
          {({region, club}: BreadCrumbsQueriesData) => {
            if (region && club) {
              return (
                <Breadcrumb>
                  <Breadcrumb.Item>{this.createLink(region.id, region.name)}</Breadcrumb.Item>
                  <Breadcrumb.Item>{club.name}</Breadcrumb.Item>
                </Breadcrumb>
              );
            }
            return null;
          }}
        </BreadCrumbsQueries>
      );
    } else if (path[1]) {
      return (
        <BreadCrumbsQueries regionId={path[1]}>
          {({region}: BreadCrumbsQueriesData) => {
            if (region) {
              return (
                <Breadcrumb>
                  <Breadcrumb.Item>{region.name}</Breadcrumb.Item>
                </Breadcrumb>
              );
            }
            return null;
          }}
        </BreadCrumbsQueries>
      );
    }

    return null;
  }

  render() {
    return (
      <>
        <div style={{marginBottom: 15}}>{this.getBreadCrumbs()}</div>
        {this.getScene()}
      </>
    );
  }
}

export default withRouter(MembershipsPage);



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/MembershipsPage.tsx